import { Inbox, type LucideIcon } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  title: string;
  hint?: React.ReactNode;
  Icon?: LucideIcon;
  action?: React.ReactNode;
  compact?: boolean;
  className?: string;
}

/**
 * Единое оформление пустых списков — парный к ErrorState.
 *
 * Пустой экран без подписи читается как сбой загрузки: пользователь ждёт, потом
 * жмёт F5. Поэтому у каждого списка должно быть явное «здесь пока пусто, и вот
 * почему».
 *
 * @use список пуст или поиск ничего не нашёл — вместо своей вёрстки «ничего не найдено» (закон 7).
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  hint,
  Icon = Inbox,
  action,
  compact = false,
  className,
}) => (
  <div className={cn(styles.root, compact && styles.rootCompact, className)}>
    <div className={styles.icon}>
      <Icon size={compact ? 18 : 26} aria-hidden />
    </div>
    <div className={styles.title}>{title}</div>
    {hint && <p className={styles.hint}>{hint}</p>}
    {action && <div className={styles.action}>{action}</div>}
  </div>
);
